import useTenantName from '@lib/hooks/useTenantName';
import { Tag } from '@servicetitan/design-system';

type Props = {
  active?: boolean;
  tenantNameOrId: string;
};

const TenantTag = ({ active = false, tenantNameOrId }: Props) => {
  const name = useTenantName(tenantNameOrId);

  return (
    <div className='d-f'>
      <Tag color='inactive' subtle={!active}>
        {name}
      </Tag>
    </div>
  );
};

export default TenantTag;
